/**
 * Initial state for the Subscription module
 *
 * @type IRevenueCatState
 */
const state: IRevenueCatState = {
	activePackage: null,
	availableOfferings: null,
	customerInfo: null,
	hasPremium: false,
	isLoadingOfferings: false,
	isPurchasing: false,
	isRestoring: false,
	lastError: null,
	lastStatusCheck: null,
	selectedPackage: null,
};

export default state;
